// extracted by mini-css-extract-plugin
export default {"assignTasksRow":"assignTasksRow---Xw_Tb","assignTasksSubRow":"assignTasksSubRow---ApTBE"};